export default "__VITE_ASSET__BmHmHFUT__"